import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const GreetingCard = ({
  username = "Utilisateur",
  percent = 70,
  objectif = "votre objectif",
  buttonText = "On y retourne ?",
  illustration,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }} // démarre invisible et légèrement en bas
      animate={{ opacity: 1, y: 0 }} // animation vers visible et en place
      transition={{ duration: 0.6, ease: "easeOut" }} // durée de l'animation
      className="bg-[#009688] text-white rounded-2xl flex justify-between items-center p-6 w-full px-[58px]"
    >
      {/* Texte à gauche */}
      <div className="max-w-md">
        <h2 className="text-2xl font-bold mb-2">
          Bonjour{username ? ` ${username}` : " !"}
        </h2>
        <p className="m-0">
          Vous avez atteint{" "}
          <span className="text-yellow-300 font-semibold">{percent} %</span> de{" "}
          <span className="text-orange-400 font-semibold">{objectif}</span>{" "}
          cette semaine
        </p>
        <p className="mb-3">Continuez comme ça et améliorez vos résultats !</p>
        <Link
          to="/pratique"
          className="bg-orange-400 text-black font-medium py-2 px-4 rounded-full border-2 border-transparent hover:border-white hover:bg-orange-500 group transition inline-flex items-center no-underline"
        >
          {buttonText}
          <span className="ml-2 text-black group-hover:text-white transition">
            →
          </span>
        </Link>
      </div>

      {/* Illustration à droite */}
      {illustration && (
        <div className="hidden md:block w-40 h-40">
          <img
            src={illustration}
            alt="Illustration"
            className="w-full h-full object-contain relative"
          />
        </div>
      )}
    </motion.div>
  );
};

export default GreetingCard;
